export const SD_Roles = {
    ADMIN : "ADMIN",
    PATIENT : "PATIENT",
    DOCTOR : "DOCTOR",
  }

  export const Appointment_Status = [ "Pending","Approved","Cancelled","Completed"]
  export const backendUrl = "https://smart-health-001-7e72a5e2a7a1.herokuapp.com/api/"
  export const devBaseUrl = "https://localhost:7182/api/"
  export const prodBaseUrl = "https://smart-health-001-7e72a5e2a7a1.herokuapp.com/api/"


  